export default {
  methods: {
    /**
     * Contract for players status
     * @param {Object} - params
     */
    getPlayerStatus (player) {
      // State
      const STATUS_OFFLINE = 'offline'
      const STATUS_UNCONFIGURED = 'unconfigured'
      const STATUS_FAILED = 'failed'
      const STATUS_FIRMWARE_UPDATE = 'firmwareUpdate'
      const STATUS_CONFIG_PENDING = 'configPending'
      const STATUS_CONFIG_PENDING_ERROR = 'configPendingError'
      const STATUS_DEGRADED = 'degraded'
      const STATUS_PUBLISH = 'publish'
      const STATUS_UPDATING = 'updating'

      // Status Color
      const STATUS_PLAYER_COLOR_GREEN = '#7cc57c'
      const STATUS_PLAYER_COLOR_ORANGE = '#FFA500'
      const STATUS_PLAYER_COLOR_RED = '#f1606d'
      const COLOR_GREEN = 'green'
      const COLOR_ORANGE = 'orange'
      const COLOR_RED = 'red'

      const playerStatus = player.status
      const checkGreenIcon = 'player-green-check-icon'
      const warningIcon = 'player-warning-icon'
      const unconfiguredIcon = warningIcon
      const updatingIcon = 'player-updating-icon'
      const checkOrangeIcon = 'player-orange-check-icon'
      const publish = 'player-publish-icon'
      const res = {
        status: 'ok',
        label: this.$t('label.ok'),
        description: null,
        iconClassName: checkGreenIcon,
        iconColor: COLOR_GREEN,
        iconStyleProp: {
          fillColor: STATUS_PLAYER_COLOR_GREEN,
          strokeColor: STATUS_PLAYER_COLOR_GREEN
        },
        notOk: false
      }

      if (!player.online || ['disconnected'].indexOf(playerStatus) >= 0) {
        res.status = STATUS_OFFLINE
        res.label = this.$t('label.offline')
        res.iconClassName = warningIcon
        res.iconStyleProp.fillColor = STATUS_PLAYER_COLOR_RED
        res.iconStyleProp.strokeColor = STATUS_PLAYER_COLOR_RED
        res.iconColor = COLOR_RED
        res.notOk = true
      } else {
        if (playerStatus === STATUS_UNCONFIGURED) { // unconfigured
          res.status = STATUS_UNCONFIGURED
          res.label = this.$t('label.notConfigured')
          res.iconClassName = unconfiguredIcon
          res.iconStyleProp.fillColor = STATUS_PLAYER_COLOR_RED
          res.iconStyleProp.strokeColor = STATUS_PLAYER_COLOR_RED
          res.iconColor = COLOR_RED
          res.notOk = true
        } else if (playerStatus === STATUS_FAILED) { // failed
          res.status = STATUS_FAILED
          res.label = this.$t('label.failed')
          res.iconClassName = warningIcon
          res.iconStyleProp.fillColor = STATUS_PLAYER_COLOR_RED
          res.iconStyleProp.strokeColor = STATUS_PLAYER_COLOR_RED
          res.iconColor = COLOR_RED
          res.notOk = true
        } else if (player.firmwareUpdate) { // firmwareUpdate
          res.status = STATUS_FIRMWARE_UPDATE
          res.label = this.$t('label.firmwareUpdate')
          res.iconClassName = checkOrangeIcon
          res.iconStyleProp.fillColor = STATUS_PLAYER_COLOR_ORANGE
          res.iconStyleProp.strokeColor = STATUS_PLAYER_COLOR_ORANGE
          res.iconColor = COLOR_ORANGE
          res.notOk = true
        } else if (player.configPending) { // configPending
          if (player.configPending.error) {
            res.status = STATUS_CONFIG_PENDING_ERROR
            res.label = this.$t('label.configError')
            res.description = player.configPending.error
          } else if (player.firmwareUpdate) {
            res.status = STATUS_FIRMWARE_UPDATE
            res.label = this.$t('label.firmwareUpdate')
          } else {
            res.status = STATUS_CONFIG_PENDING
            res.label = this.$t('label.configPending')
          }

          res.iconClassName = checkOrangeIcon
          res.iconStyleProp.fillColor = STATUS_PLAYER_COLOR_ORANGE
          res.iconStyleProp.strokeColor = STATUS_PLAYER_COLOR_ORANGE
          res.iconColor = COLOR_ORANGE
          res.notOk = true
        } else if (player.degraded) {
          res.status = STATUS_DEGRADED
          res.label = this.$t('label.slowSync')
          res.iconClassName = checkOrangeIcon
          res.iconStyleProp.fillColor = STATUS_PLAYER_COLOR_ORANGE
          res.iconStyleProp.strokeColor = STATUS_PLAYER_COLOR_ORANGE
          res.iconColor = COLOR_ORANGE
          res.notOk = true
        } else if (playerStatus === STATUS_PUBLISH) {
          res.status = STATUS_PUBLISH
          res.label = this.$t('label.ok')
          res.iconClassName = publish
          res.iconStyleProp.fillColor = STATUS_PLAYER_COLOR_GREEN
          res.iconStyleProp.strokeColor = STATUS_PLAYER_COLOR_GREEN
          res.iconColor = COLOR_GREEN
          res.notOk = false
        } else if (playerStatus === STATUS_UPDATING) {
          res.status = STATUS_UPDATING
          res.label = this.$t('label.ok')
          res.iconClassName = updatingIcon
          res.notOk = false
          res.iconStyleProp.fillColor = STATUS_PLAYER_COLOR_GREEN
          res.iconStyleProp.strokeColor = STATUS_PLAYER_COLOR_GREEN
          res.iconColor = COLOR_GREEN
        }
      }

      return res
    }
  }
}
